import { motion } from 'framer-motion'

// Utils
import { pageVariants } from 'components/interestform/utils'

import commonStyles from 'components/interestform/slides/common.css'
import styles from './subscription.css'

const Subscription = (): JSX.Element => {
  return (
    <motion.div className={styles.wrapper} initial="initial" animate="in" exit="out" variants={pageVariants}>
      <div className={styles.splitPanel}>
        <div className={styles.leftPanel}>
          <h1 className={commonStyles.heading}>Subscription-based</h1>
          <div className={commonStyles.subheading}>Tracklib is an online subscription service for musicians and producers worldwide</div>
          <div className={commonStyles.textContent}>
            <div className={commonStyles.paragraph}>Our subscribers can download high-quality files of original recordings</div>
            <div className={commonStyles.paragraph}>
              Master owners get 50% of gross revenues generated through track downloads on subscriptions, and publishing owners get a fee of
              $9.1 cents per download
            </div>
          </div>
        </div>
        <div className={styles.rightPanel}>
          <div className={styles.imageWrapper}>
            <img src="/static/images/interestform/subscribe-screenshot.jpg" alt="Tracklib Homepage Screenshot" className={styles.image} />
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default Subscription
